import Vue from 'vue'
import Router from 'vue-router'
import App from '@/App'
import Dashboard from '@/components/Dashboard'

import Maincategory from '@/components/Dashboard/Maincategory'
import MaincategoryYear from '@/components/Dashboard/MaincategoryYear'
import MaincategoryHatg from '@/components/Dashboard/MaincategoryHatg'
import MaincategoryAtg from '@/components/Dashboard/MaincategoryAtg'

import Brand from '@/components/Dashboard/Brand'
import BrandYear from '@/components/Dashboard/BrandYear'
import BrandBrand from '@/components/Dashboard/BrandBrand'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: __dirname,
    routes: [{
            path: '/',
            redirect: '/dashboard'
        },
        {
            path: '/app',
            component: App,
            children: [
                /*
                {
                  path: '/auth/login',
                  component: Login,
                  name: 'Login',
                },
                {
                  path: '/auth/logout',
                  component: Logout,
                  name: 'Logout',
                },
                */
                {
                    path: '/dashboard',
                    component: Dashboard,
                    name: 'dashboard',
                    children: [{
                            path: 'stats/maincategories',
                            component: Dashboard,
                            name: 'dsm',
                        },
                        {
                            path: 'stats/maincategories/:year',
                            component: Dashboard,
                            name: 'dsmy',
                            children: [{
                                path: ':cat',
                                component: Dashboard,
                                name: 'dsmc',
                                children: [{
                                    path: ':scat',
                                    component: Dashboard,
                                    name: 'dsms',
                                }, ],
                            }, ],
                        },
                        {
                            path: 'stats/brands',
                            component: Dashboard,
                            name: 'dsb',
                        },
                        {
                            path: 'stats/brands/:brandyear',
                            component: Dashboard,
                            name: 'dsby',
                            children: [{
                                path: ':brandbrand',
                                component: Dashboard,
                                name: 'dsbb',
                                children: [{
                                    path: ':brandscat',
                                    component: Dashboard,
                                    name: 'dsbs',
                                }, ],
                            }, ],
                        },
                        {
                            // UserProfile wird innerhalb der
                            // <router-view> von User gerendert,
                            // wenn '/user/:id/profile' gematched wird.
                            path: 'statistics/maincategories',
                            component: Maincategory,
                            name: 'statisticsmc'
                        },
                        {
                            // UserProfile wird innerhalb der
                            // <router-view> von User gerendert,
                            // wenn '/user/:id/profile' gematched wird.
                            path: 'statistics/maincategories/:year',
                            component: MaincategoryYear,
                            name: 'statisticsmcy'
                        },
                        {
                            // UserProfile wird innerhalb der
                            // <router-view> von User gerendert,
                            // wenn '/user/:id/profile' gematched wird.
                            path: 'statistics/maincategories/:year/:hatg',
                            component: MaincategoryHatg,
                            name: 'statisticsmcyh'
                        },
                        {
                            // UserProfile wird innerhalb der
                            // <router-view> von User gerendert,
                            // wenn '/user/:id/profile' gematched wird.
                            path: 'statistics/maincategories/:year/:hatg/:atg',
                            component: MaincategoryAtg,
                            name: 'statisticsmcyha'
                        },
                        {
                            // UserProfile wird innerhalb der
                            // <router-view> von User gerendert,
                            // wenn '/user/:id/profile' gematched wird.
                            path: 'statistics/brands',
                            component: Brand,
                            name: 'statisticsb'
                        },
                        {
                            // UserProfile wird innerhalb der
                            // <router-view> von User gerendert,
                            // wenn '/user/:id/profile' gematched wird.
                            path: 'statistics/brands/:year',
                            component: BrandYear,
                            name: 'statisticsby'
                        },
                        {
                            // UserProfile wird innerhalb der
                            // <router-view> von User gerendert,
                            // wenn '/user/:id/profile' gematched wird.
                            path: 'statistics/brands/:year/:brand',
                            component: BrandBrand,
                            name: 'statisticsbyb'
                        },
                    ],
                }
            ]
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js